import {ArticleCollections} from './ArticleCollections';
export default ArticleCollections;
